<template>
  <section>
    <section class="hero is-info">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">Usuarios</h1>
          <h2 class="subtitle">
            Crea los usuarios que pueden acceder a yungol
          </h2>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="container">
        <section class="margin-top">
          <div class="field">
            <div class="control has-icons-left">
              <input
                class="input is-large"
                type="text"
                placeholder="Nombre"
                v-model="user.displayName"
              />
              <span class="icon is-medium is-left">
                <i class="material-icons">person</i>
              </span>
            </div>
          </div>
          <div class="field">
            <div class="control has-icons-left">
              <input
                class="input is-large"
                type="email"
                placeholder="Correo"
                v-model="user.email"
              />
              <span class="icon is-medium is-left">
                <i class="material-icons">email</i>
              </span>
            </div>
          </div>
          <div class="field">
            <p class="control has-icons-left">
              <span class="select is-large is-fullwidth">
                <select v-model="current">
                  <option
                    v-for="option in empresas"
                    v-bind:value="option"
                    v-bind:key="option._id"
                  >
                    {{ option.nombrec }} {{ option.nit }}
                  </option>
                </select>
              </span>
              <span class="icon is-small is-left">
                <i class="material-icons">location_city</i>
              </span>
            </p>
          </div>
          <div class="field">
            <div class="columns is-multiline">
              <div class="column">
                <input
                  v-model="user.claims.admin"
                  class="is-checkradio"
                  id="ch"
                  type="checkbox"
                  name="ch"
                />
                <label for="ch">admin</label>
              </div>
              <div class="column">
                <input
                  v-model="user.claims.contador"
                  class="is-checkradio"
                  id="ch1"
                  type="checkbox"
                  name="ch1"
                />
                <label for="ch1">contador</label>
              </div>
              <div class="column">
                <input
                  v-model="user.claims.auxiliar"
                  class="is-checkradio"
                  id="ch2"
                  type="checkbox"
                  name="ch2"
                />
                <label for="ch2">auxiliar</label>
              </div>
              <div class="column">
                <input
                  v-model="user.claims.gerente"
                  class="is-checkradio"
                  id="ch3"
                  type="checkbox"
                  name="ch3"
                />
                <label for="ch3">gerente</label>
              </div>
              <div class="column">
                <input
                  v-model="user.claims.help"
                  class="is-checkradio"
                  id="ch3"
                  type="checkbox"
                  name="ch3"
                />
                <label for="ch3">help</label>
              </div>
              <div class="column">
                <input
                  v-model="user.claims.vendedor"
                  class="is-checkradio"
                  id="ch4"
                  type="checkbox"
                  name="ch4"
                />
                <label for="ch4">vendedor</label>
              </div>
              <div class="column">
                <input
                  v-model="user.claims.developer"
                  class="is-checkradio"
                  id="ch7"
                  type="checkbox"
                  name="ch7"
                />
                <label for="ch7">Desarrollador</label>
              </div>
              <div class="column">
                <input
                  v-model="user.claims.proyectos"
                  class="is-checkradio"
                  id="ch8"
                  type="checkbox"
                  name="ch8"
                />
                <label for="ch8">Proyectos</label>
              </div>
              <div class="column">
                <input
                  v-model="user.claims.task"
                  class="is-checkradio"
                  id="ch9"
                  type="checkbox"
                  name="ch9"
                />
                <label for="ch9">Task</label>
              </div>
            </div>
          </div>
          <div class="field is-grouped">
            <div class="control">
              <button class="button is-info is-large" @click="enviar">
                Enviar
              </button>
            </div>
            <div class="control">
              <button class="button is-large" @click="borrar">Cancelar</button>
            </div>
          </div>
        </section>
      </div>
    </section>
  </section>
</template>

<script>
import apiServices from "@/services/yungol-services";
import { mapState } from "vuex";
export default {
  data() {
    return {
      user: {
        currentCompany: "",
        companys: {},
        claims: {},
      },
      empresas: [],
      current: "",
    };
  },
  computed: {
    ...mapState(["idtoken"]),
  },
  methods: {
    borrar() {
      this.nombre = "";
      this.valor = "";
    },
    async enviar() {
      let result;
      try {
        this.user.currentCompany = this.current._id;
        this.user.companys = {};
        this.user.companys[this.current._id] = {
          id: this.current._id,
        };
        result = await apiServices.post(`/users`, this.user);
        this.$store.dispatch("notify", {
          message: `Perfecto. Usuario creado con éxito`,
        });
        console.log(result);
      } catch (error) {
        console.log(error);
        this.$store.dispatch("notify", {
          message: "Ups, ocurrió un error. Inténtelo nuevamente",
          type: "is-danger",
          duration: 4000,
        });
      }
    },
  },
  mounted: function () {
    async function enviar(_this) {
      let result;
      const d = {
        _id: "",
        nombrec: "Empresa",
        nit: "",
      };
      try {
        result = await apiServices.get(`/empresas`);
        _this.empresas = [].concat([d], result.data);
        _this.current = d;
      } catch (error) {
        console.log(error);
      }
    }
    enviar(this);
  },
};
</script>

<style lang="scss" scoped>
.is-checkradio[type="radio"]:checked + label::before,
.is-checkradio[type="radio"]:checked + label:before,
.is-checkradio[type="checkbox"]:checked + label::before,
.is-checkradio[type="checkbox"]:checked + label:before {
  border: 0.15rem solid #dbdbdb;
}
.is-checkradio[type="checkbox"] + label::after,
.is-checkradio[type="checkbox"] + label:after {
  border-width: 0.15rem;
}
</style>





// WEBPACK FOOTER //
// src/components/admin/AddUser.vue